import * as Sentry from "@sentry/react";

const dsn = import.meta.env.VITE_SENTRY_DSN;
const tracesSampleRate = parseSampleRate(
  import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE,
  0,
);
const replaysSessionSampleRate = parseSampleRate(
  import.meta.env.VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE,
  0,
);
const replaysOnErrorSampleRate = parseSampleRate(
  import.meta.env.VITE_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE,
  1,
);

if (dsn) {
  Sentry.init({
    dsn,
    environment:
      import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE,
    release: import.meta.env.VITE_SENTRY_RELEASE,
    enableLogs: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        maskAllInputs: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate,
    replaysSessionSampleRate,
    replaysOnErrorSampleRate,
    tracePropagationTargets: [
      /^\/$/,
      /^\/ws$/,
      /^https:\/\/game\.dev\.n0n3\.ru/,
      /^https:\/\/game\.playtest\.n0n3\.ru/,
      /^https:\/\/game\.n0n3\.ru/,
    ],
  });
}

function parseSampleRate(value: string | undefined, fallback: number) {
  const sampleRate = Number.parseFloat(value || "");
  if (!Number.isFinite(sampleRate)) {
    return fallback;
  }

  return Math.min(1, Math.max(0, sampleRate));
}
